import { defineAsyncComponent } from "vue";

export default [
  {
    name: "AlsSessionAttemptCover",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerCover")),
    path: "",
    props: true,
  },
  {
    name: "AlsSessionAttemptEnd",
    component: defineAsyncComponent(() => import("@modules/attempt/components/LessonViewerEnd")),
    path: "end",
    props: true,
  },
  {
    name: "AlsSessionAttemptSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionCover"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "AlsSessionAttemptSectionEnd",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerSectionEnd"),
    ),
    path: "section/:sectionId/end",
    props: true,
  },
  {
    name: "AlsSessionAttemptActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerActivity"),
    ),
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    name: "AlsSessionAttemptCommonSpaceView",
    component: defineAsyncComponent(() => import("@modules/attempt/components/CommonSpace")),
    path: "section/:sectionId/activity/:pageId/common-space/:componentId",
    props: true,
  },
  {
    name: "AlsSessionAttemptConversationRoomView",
    component: defineAsyncComponent(
      () => import("@modules/conversation/components/ConversationRoom.vue"),
    ),
    path: "section/:sectionId/activity/:pageId/conversation-room/:resourceUuid",
    props: true,
  },
  {
    path: "not-found",
    name: "AlsSessionAttemptNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonViewerNotFoundPage"),
    ),
  },
];
